import { Truck, ArrowsClockwise, ShieldCheck, Package, Globe, EnvelopeSimple } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

export default function ShippingReturns() {
  return (
    <div data-testid="shipping-returns-page">
      <section className="max-w-3xl mx-auto px-6 pt-16 pb-8">
        <div className="overline text-[#4A1525] mb-4">Care</div>
        <h1 className="font-serif text-5xl md:text-7xl tracking-tighter leading-[0.95] mb-6">Shipping<br/>& returns.</h1>
        <p className="text-[#5C5C5C] text-lg leading-relaxed">
          A parcel from Iamravishing arrives the way it should — quietly, considered, and always in unmarked packaging.
        </p>
      </section>

      <section className="max-w-3xl mx-auto px-6 py-8 grid md:grid-cols-3 gap-6 border-y border-[#E6DED5]">
        <div className="flex flex-col items-center text-center py-6 gap-2">
          <Truck size={32} weight="light" color="#4A1525" />
          <div className="font-serif text-lg mt-2">Free over ₹5,000</div>
          <div className="overline text-[#5C5C5C]">Complimentary shipping</div>
        </div>
        <div className="flex flex-col items-center text-center py-6 gap-2">
          <ArrowsClockwise size={32} weight="light" color="#4A1525" />
          <div className="font-serif text-lg mt-2">30-day returns</div>
          <div className="overline text-[#5C5C5C]">Unworn & tagged</div>
        </div>
        <div className="flex flex-col items-center text-center py-6 gap-2">
          <ShieldCheck size={32} weight="light" color="#4A1525" />
          <div className="font-serif text-lg mt-2">Discreet always</div>
          <div className="overline text-[#5C5C5C]">Unmarked packaging</div>
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-6 py-16 space-y-14">
        <div>
          <div className="flex items-center gap-3 mb-4"><Package size={22} weight="light" color="#4A1525" /><h2 className="font-serif text-3xl">Shipping</h2></div>
          <table className="w-full text-sm border-collapse">
            <thead>
              <tr className="border-b border-[#1A1A1A]">
                <th className="overline text-left py-3">Region</th>
                <th className="overline text-left py-3">Timing</th>
                <th className="overline text-left py-3">Cost</th>
              </tr>
            </thead>
            <tbody className="[&>tr]:border-b [&>tr]:border-[#E6DED5]">
              <tr><td className="py-3">India</td><td className="py-3">3–6 business days</td><td className="py-3">₹200 · Free over ₹5,000</td></tr>
              <tr><td className="py-3">United States</td><td className="py-3">6–9 business days</td><td className="py-3">₹1,500</td></tr>
              <tr><td className="py-3">Canada</td><td className="py-3">7–10 business days</td><td className="py-3">₹1,800</td></tr>
              <tr><td className="py-3">United Kingdom & EU</td><td className="py-3">6–10 business days</td><td className="py-3">₹2,200</td></tr>
              <tr><td className="py-3">Rest of world</td><td className="py-3">10–14 business days</td><td className="py-3">₹3,000</td></tr>
              <tr><td className="py-3" style={{display:"none"}}>Legacy</td><td className="py-3" style={{display:"none"}}>—</td><td className="py-3" style={{display:"none"}}>—</td></tr>
            </tbody>
          </table>
          <p className="text-sm text-[#5C5C5C] mt-4 leading-relaxed">Orders are dispatched within 1–2 business days from our atelier in Mumbai. You'll receive a tracking number by email the moment your parcel leaves us.</p>
        </div>

        <div>
          <div className="flex items-center gap-3 mb-4"><ArrowsClockwise size={22} weight="light" color="#4A1525" /><h2 className="font-serif text-3xl">Returns</h2></div>
          <div className="space-y-4 text-[#5C5C5C] leading-relaxed">
            <p>For reasons of hygiene, unworn pieces may be returned within <strong className="text-[#1A1A1A]">30 days</strong> of delivery, in original packaging with the hygienic strip and all tags intact.</p>
            <p>The following items are <strong className="text-[#1A1A1A]">final sale</strong> and cannot be returned or exchanged:</p>
            <ul className="list-disc list-inside space-y-1 pl-2">
              <li>Panties, briefs, and thongs</li>
              <li>Pieces marked "final sale" at purchase</li>
              <li>Gift cards and monogrammed items</li>
            </ul>
            <p>To initiate a return, email us at <a href="mailto:admin@iamravishing.com" className="text-[#4A1525] underline underline-offset-4">admin@iamravishing.com</a> with your order number. Refunds are issued to the original payment method within 5–7 business days of receipt.</p>
          </div>
        </div>

        <div>
          <div className="flex items-center gap-3 mb-4"><Globe size={22} weight="light" color="#4A1525" /><h2 className="font-serif text-3xl">Duties & customs</h2></div>
          <p className="text-[#5C5C5C] leading-relaxed">International orders may be subject to customs duties or taxes on arrival, determined by your country. These are the responsibility of the customer.</p>
        </div>

        <div className="pt-8 border-t border-[#E6DED5]">
          <p className="text-[#5C5C5C]">Still have questions? <Link to="/contact" className="text-[#4A1525] underline underline-offset-4" data-testid="link-to-contact">Contact us</Link>.</p>
        </div>
      </section>
    </div>
  );
}
